// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderClaimPayment,
    ProviderPaymentSortType,
    SupportClaimPayment,
    SupportCreateClaimPaymentFromClearinghouseEraItemPayload,
    SupportCreateClaimPaymentPayload,
    SupportPaymentSortType,
    SupportUpdatePaymentPayload,
    SupportCreateClaimPaymentFromClearinghouseEraItemPayloadToJSON,
    SupportCreateClaimPaymentPayloadToJSON,
    SupportUpdatePaymentPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderClaimPaymentFromJSON,
    SupportClaimPaymentFromJSON,
    SupportCreateClaimPaymentPayloadFromJSON,
} from '../models';

export interface CreateSupportClaimPaymentRequest {
    supportCreateClaimPaymentPayload: SupportCreateClaimPaymentPayload;
    bypass?: boolean;
}

export interface CreateSupportClaimPaymentFromClearinghouseEraItemRequest {
    id: string;
    supportCreateClaimPaymentFromClearinghouseEraItemPayload: SupportCreateClaimPaymentFromClearinghouseEraItemPayload;
}

export interface CreateSupportClaimPaymentPayloadRequest {
    id: string;
}

export interface DisableSupportClaimPaymentRequest {
    id: string;
}

export interface GetProviderClaimPaymentRequest {
    id: string;
}

export interface GetSupportClaimPaymentRequest {
    id: string;
}

export interface ListProviderClaimPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClaimPaymentsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterPayerId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterControlNumber?: Array<string>;
    filterPaymentDate?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterProviderId?: Array<string>;
    filterRemark?: Array<string>;
    filterStatus?: Array<string>;
    filterAdjustmentGroup?: Array<string>;
    filterAdjustmentReason?: Array<string>;
    filterTotalAmount?: Array<string>;
    filterAllowedAmount?: Array<string>;
    filterPayerAmount?: Array<string>;
    filterPatientAmount?: Array<string>;
    filterEob?: Array<string>;
    filterClaimType?: ListProviderClaimPaymentsFilterClaimTypeEnum;
    sort?: Array<ProviderPaymentSortType>;
}

export interface ListSupportClaimPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClaimPaymentsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterClaimId?: Array<string>;
    filterPayerId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterSettled?: string;
    filterControlNumber?: Array<string>;
    filterPaymentDate?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterProviderId?: Array<string>;
    filterRemark?: Array<string>;
    filterStatus?: Array<string>;
    filterAdjustmentGroup?: Array<string>;
    filterAdjustmentReason?: Array<string>;
    filterTotalAmount?: Array<string>;
    filterAllowedAmount?: Array<string>;
    filterPayerAmount?: Array<string>;
    filterPatientAmount?: Array<string>;
    filterClearinghouseEraItem?: Array<string>;
    filterEob?: Array<string>;
    filterClaimType?: ListSupportClaimPaymentsFilterClaimTypeEnum;
    sort?: Array<SupportPaymentSortType>;
}

export interface UnsettleSupportClaimPaymentRequest {
    id: string;
}

export interface UpdateSupportClaimPaymentRequest {
    id: string;
    supportUpdatePaymentPayload: SupportUpdatePaymentPayload;
}

/**
 * no description
 */
export class PaymentApi extends runtime.BaseAPI {

    /**
     * Create a claim payment
     * Create a claim payment
     */
    async createSupportClaimPaymentRaw(requestParameters: CreateSupportClaimPaymentRequest): Promise<runtime.ApiResponse<SupportClaimPayment>> {
        if (requestParameters['supportCreateClaimPaymentPayload'] === null || requestParameters['supportCreateClaimPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimPaymentPayload','Required parameter requestParameters.supportCreateClaimPaymentPayload was null or undefined when calling createSupportClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.bypass !== undefined) {
            queryParameters['bypass'] = requestParameters.bypass;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimPaymentPayloadToJSON(requestParameters['supportCreateClaimPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentFromJSON(jsonValue));
    }

    /**
     * Create a claim payment
     * Create a claim payment
     */
    async createSupportClaimPayment(requestParameters: CreateSupportClaimPaymentRequest): Promise<SupportClaimPayment> {
        const response = await this.createSupportClaimPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim payment from a clearinghouse era item
     * Create a claim payment from clearinghouse era item
     */
    async createSupportClaimPaymentFromClearinghouseEraItemRaw(requestParameters: CreateSupportClaimPaymentFromClearinghouseEraItemRequest): Promise<runtime.ApiResponse<SupportClaimPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClaimPaymentFromClearinghouseEraItem.');
        }

        if (requestParameters['supportCreateClaimPaymentFromClearinghouseEraItemPayload'] === null || requestParameters['supportCreateClaimPaymentFromClearinghouseEraItemPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClaimPaymentFromClearinghouseEraItemPayload','Required parameter requestParameters.supportCreateClaimPaymentFromClearinghouseEraItemPayload was null or undefined when calling createSupportClaimPaymentFromClearinghouseEraItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/era/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClaimPaymentFromClearinghouseEraItemPayloadToJSON(requestParameters['supportCreateClaimPaymentFromClearinghouseEraItemPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentFromJSON(jsonValue));
    }

    /**
     * Create a claim payment from a clearinghouse era item
     * Create a claim payment from clearinghouse era item
     */
    async createSupportClaimPaymentFromClearinghouseEraItem(requestParameters: CreateSupportClaimPaymentFromClearinghouseEraItemRequest): Promise<SupportClaimPayment> {
        const response = await this.createSupportClaimPaymentFromClearinghouseEraItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a create claim payment payload
     * Create a create claim payment payload
     */
    async createSupportClaimPaymentPayloadRaw(requestParameters: CreateSupportClaimPaymentPayloadRequest): Promise<runtime.ApiResponse<Array<SupportCreateClaimPaymentPayload>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClaimPaymentPayload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/document/{id}/payload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCreateClaimPaymentPayloadFromJSON));
    }

    /**
     * Create a create claim payment payload
     * Create a create claim payment payload
     */
    async createSupportClaimPaymentPayload(requestParameters: CreateSupportClaimPaymentPayloadRequest): Promise<Array<SupportCreateClaimPaymentPayload>> {
        const response = await this.createSupportClaimPaymentPayloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a claim payment
     * Disable a claim payment
     */
    async disableSupportClaimPaymentRaw(requestParameters: DisableSupportClaimPaymentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a claim payment
     * Disable a claim payment
     */
    async disableSupportClaimPayment(requestParameters: DisableSupportClaimPaymentRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportClaimPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim payment
     * Retrieve a claim payment
     */
    async getProviderClaimPaymentRaw(requestParameters: GetProviderClaimPaymentRequest): Promise<runtime.ApiResponse<ProviderClaimPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimPaymentFromJSON(jsonValue));
    }

    /**
     * Get a claim payment
     * Retrieve a claim payment
     */
    async getProviderClaimPayment(requestParameters: GetProviderClaimPaymentRequest): Promise<ProviderClaimPayment> {
        const response = await this.getProviderClaimPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim payment
     * Retrieve a claim payment
     */
    async getSupportClaimPaymentRaw(requestParameters: GetSupportClaimPaymentRequest): Promise<runtime.ApiResponse<SupportClaimPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentFromJSON(jsonValue));
    }

    /**
     * Get a claim payment
     * Retrieve a claim payment
     */
    async getSupportClaimPayment(requestParameters: GetSupportClaimPaymentRequest): Promise<SupportClaimPayment> {
        const response = await this.getSupportClaimPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of uncorrelated claims
     * Get a list of claim payments
     */
    async listProviderClaimPaymentsRaw(requestParameters: ListProviderClaimPaymentsRequest): Promise<runtime.ApiResponse<Array<ProviderClaimPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterControlNumber) {
            queryParameters['filterControlNumber'] = requestParameters.filterControlNumber;
        }

        if (requestParameters.filterPaymentDate) {
            queryParameters['filterPaymentDate'] = requestParameters.filterPaymentDate;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterRemark) {
            queryParameters['filterRemark'] = requestParameters.filterRemark;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterAdjustmentGroup) {
            queryParameters['filterAdjustmentGroup'] = requestParameters.filterAdjustmentGroup;
        }

        if (requestParameters.filterAdjustmentReason) {
            queryParameters['filterAdjustmentReason'] = requestParameters.filterAdjustmentReason;
        }

        if (requestParameters.filterTotalAmount) {
            queryParameters['filterTotalAmount'] = requestParameters.filterTotalAmount;
        }

        if (requestParameters.filterAllowedAmount) {
            queryParameters['filterAllowedAmount'] = requestParameters.filterAllowedAmount;
        }

        if (requestParameters.filterPayerAmount) {
            queryParameters['filterPayerAmount'] = requestParameters.filterPayerAmount;
        }

        if (requestParameters.filterPatientAmount) {
            queryParameters['filterPatientAmount'] = requestParameters.filterPatientAmount;
        }

        if (requestParameters.filterEob) {
            queryParameters['filterEob'] = requestParameters.filterEob;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimPaymentFromJSON));
    }

    /**
     * Gets a list of uncorrelated claims
     * Get a list of claim payments
     */
    async listProviderClaimPayments(requestParameters: ListProviderClaimPaymentsRequest): Promise<Array<ProviderClaimPayment>> {
        const response = await this.listProviderClaimPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of uncorrelated claims
     * Get a list of claim payments
     */
    async listSupportClaimPaymentsRaw(requestParameters: ListSupportClaimPaymentsRequest): Promise<runtime.ApiResponse<Array<SupportClaimPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterSettled !== undefined) {
            queryParameters['filterSettled'] = requestParameters.filterSettled;
        }

        if (requestParameters.filterControlNumber) {
            queryParameters['filterControlNumber'] = requestParameters.filterControlNumber;
        }

        if (requestParameters.filterPaymentDate) {
            queryParameters['filterPaymentDate'] = requestParameters.filterPaymentDate;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterRemark) {
            queryParameters['filterRemark'] = requestParameters.filterRemark;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterAdjustmentGroup) {
            queryParameters['filterAdjustmentGroup'] = requestParameters.filterAdjustmentGroup;
        }

        if (requestParameters.filterAdjustmentReason) {
            queryParameters['filterAdjustmentReason'] = requestParameters.filterAdjustmentReason;
        }

        if (requestParameters.filterTotalAmount) {
            queryParameters['filterTotalAmount'] = requestParameters.filterTotalAmount;
        }

        if (requestParameters.filterAllowedAmount) {
            queryParameters['filterAllowedAmount'] = requestParameters.filterAllowedAmount;
        }

        if (requestParameters.filterPayerAmount) {
            queryParameters['filterPayerAmount'] = requestParameters.filterPayerAmount;
        }

        if (requestParameters.filterPatientAmount) {
            queryParameters['filterPatientAmount'] = requestParameters.filterPatientAmount;
        }

        if (requestParameters.filterClearinghouseEraItem) {
            queryParameters['filterClearinghouseEraItem'] = requestParameters.filterClearinghouseEraItem;
        }

        if (requestParameters.filterEob) {
            queryParameters['filterEob'] = requestParameters.filterEob;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimPaymentFromJSON));
    }

    /**
     * Gets a list of uncorrelated claims
     * Get a list of claim payments
     */
    async listSupportClaimPayments(requestParameters: ListSupportClaimPaymentsRequest): Promise<Array<SupportClaimPayment>> {
        const response = await this.listSupportClaimPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unsettle a support claim payment
     * Unsettle a claim payment
     */
    async unsettleSupportClaimPaymentRaw(requestParameters: UnsettleSupportClaimPaymentRequest): Promise<runtime.ApiResponse<SupportClaimPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unsettleSupportClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/{id}/unsettle`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClaimPaymentFromJSON(jsonValue));
    }

    /**
     * Unsettle a support claim payment
     * Unsettle a claim payment
     */
    async unsettleSupportClaimPayment(requestParameters: UnsettleSupportClaimPaymentRequest): Promise<SupportClaimPayment> {
        const response = await this.unsettleSupportClaimPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a claim payment
     * Update a claim payment
     */
    async updateSupportClaimPaymentRaw(requestParameters: UpdateSupportClaimPaymentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportClaimPayment.');
        }

        if (requestParameters['supportUpdatePaymentPayload'] === null || requestParameters['supportUpdatePaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePaymentPayload','Required parameter requestParameters.supportUpdatePaymentPayload was null or undefined when calling updateSupportClaimPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePaymentPayloadToJSON(requestParameters['supportUpdatePaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim payment
     * Update a claim payment
     */
    async updateSupportClaimPayment(requestParameters: UpdateSupportClaimPaymentRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportClaimPaymentRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderClaimPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClaimPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
